var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g4, _path18, _path19, _g5, _g6, _path20, _g7, _path21, _path22, _line, _path23, _path24, _path25, _path26, _path27, _line2, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 540,
    height: 376.305,
    viewBox: "0 0 540 376.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.518,
    y1: 12.033,
    x2: 0.495,
    y2: -2.561,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5693f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.517,
    y1: 138.746,
    x2: 0.495,
    y2: -44.117,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.444,
    y1: -3.321,
    x2: 0.526,
    y2: 2.117,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5693f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e5ec1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.482,
    y1: -1.419,
    x2: 0.527,
    y2: 3.251,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.761,
    y1: 0.262,
    x2: 3.097,
    y2: -1.244,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#453665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241746"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.672,
    y1: -0.906,
    x2: 0.519,
    y2: 0.517,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.555,
    y1: 0.431,
    x2: 3.237,
    y2: -0.942,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.529,
    y1: 0.567,
    x2: 1.143,
    y2: -1.744,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5c1c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db706c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.531,
    y1: -0.372,
    x2: 0.475,
    y2: 1.142,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed5ea4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.559,
    y1: -0.487,
    x2: 0.457,
    y2: 1.206,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.549,
    y1: 0.611,
    x2: 1.215,
    y2: -1.344,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.096,
    y1: 1.812,
    x2: 1.123,
    y2: -1.416,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.636,
    y1: -2.118,
    x2: 0.54,
    y2: -0.338,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.129,
    y1: 0.88,
    x2: 1.872,
    y2: -2.14,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -0.167,
    y1: -2.912,
    x2: 2.436,
    y2: 10.402,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -0.167,
    y1: -2.912,
    x2: 2.436,
    y2: 10.402,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.634,
    y1: 0.436,
    x2: 2.628,
    y2: -1.204,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -1.331,
    y1: 1.67,
    x2: 1.668,
    y2: -0.387,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.254,
    y1: 2.761,
    x2: 0.581,
    y2: 0.016,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.624,
    y1: -0.237,
    x2: 0.486,
    y2: 0.483,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.33,
    y1: 0.341,
    x2: 6.659,
    y2: 6.265,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0.457,
    y1: -0.335,
    x2: 2.074,
    y2: 0.887,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0.096,
    y1: -0.233,
    x2: 1.561,
    y2: 2.248,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -0.681,
    y1: -0.363,
    x2: 3.235,
    y2: 2.525,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 0.497,
    y1: 0.043,
    x2: 0.511,
    y2: 1.719,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c196f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a68f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1.134,
    y1: -0.567,
    x2: 0.47,
    y2: 0.872,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0.49,
    y1: 0.042,
    x2: 0.526,
    y2: 1.723,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 6.3,
    y1: -3.047,
    x2: -1.6,
    y2: 1.972,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 0.494,
    y1: 0.04,
    x2: 0.51,
    y2: 1.724,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1.949,
    y1: -0.552,
    x2: 0.624,
    y2: 0.867,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 0.625,
    y1: -0.441,
    x2: 0.113,
    y2: 2.566,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 0.096,
    y1: 1.812,
    x2: 1.123,
    y2: -1.416,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 0.636,
    y1: -2.118,
    x2: 0.54,
    y2: -0.338,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 0.129,
    y1: 0.88,
    x2: 1.872,
    y2: -2.14,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -0.167,
    y1: -2.911,
    x2: 2.437,
    y2: 10.402,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -0.167,
    y1: -2.911,
    x2: 2.436,
    y2: 10.4,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0.502,
    y1: -0.188,
    x2: 0.494,
    y2: 2.807,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 0.502,
    y1: -0.192,
    x2: 0.494,
    y2: 2.804,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 0.346,
    y1: 0.032,
    x2: 0.789,
    y2: 1.842,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 0.32,
    y1: 0.222,
    x2: 1.739,
    y2: 2.845,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1.821,
    y1: -1.136,
    x2: 1.233,
    y2: -0.438,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 0.463,
    y1: 0.75,
    x2: 3.784,
    y2: -10.886,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 0.466,
    y1: 0.209,
    x2: 0.686,
    y2: 4.147,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 0.491,
    y1: 0.638,
    x2: 2.632,
    y2: -1.615,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 2.671,
    y1: -2.74,
    x2: -0.281,
    y2: 1.779,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 0.492,
    y1: 0.148,
    x2: 0.554,
    y2: 2.277,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1.418,
    y1: -0.014,
    x2: -1.844,
    y2: 1.744,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 2.871,
    y1: -1.506,
    x2: 0.618,
    y2: 0.787,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1.844,
    y1: -1.68,
    x2: 0.35,
    y2: 0.765,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 0.038,
    y1: 0.143,
    x2: 3.31,
    y2: 1.647,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 0.277,
    y1: 1.673,
    x2: 0.988,
    y2: -2.874,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 0.106,
    y1: 0.876,
    x2: 1.85,
    y2: -1.903,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -0.167,
    y1: -2.911,
    x2: 2.436,
    y2: 10.4,
    xlinkHref: "#linear-gradient-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "vector",
    transform: "translate(-50.961 -169.392)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10488",
    "data-name": "Group 10488",
    transform: "translate(50.961 357.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12461",
    "data-name": "Path 12461",
    d: "M116.11,489.045C53.885,453.018,48.714,353,67.921,334.677s60.2,110.955,60.2,110.955S94.412,334.858,121.8,310.464s47.327,143.275,48.067,141.068-7.45-78.042,21.726-92.171,0,128.1,0,128.1l243.169-7.587S392.6,392.023,420.847,359.361s28.471,75.828,28.728,80.311S451.826,320.9,497,324.909,482.612,466.8,482.612,466.8s28.816-73.624,83.34-78.79-66.842,95.01-66.842,95.01",
    transform: "translate(-48.437 -308.038)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_355",
    "data-name": "Ellipse 355",
    cx: 270,
    cy: 7.223,
    rx: 270,
    ry: 7.223,
    transform: "translate(0 173.784)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10515",
    "data-name": "Group 10515",
    transform: "translate(53.915 169.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10500",
    "data-name": "Group 10500",
    transform: "translate(0 54.518)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10490",
    "data-name": "Group 10490",
    transform: "translate(34.847 194.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10489",
    "data-name": "Group 10489",
    transform: "translate(10.186 10.186)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2666",
    "data-name": "Rectangle 2666",
    width: 7.274,
    height: 99.471,
    transform: "translate(46.098)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2667",
    "data-name": "Rectangle 2667",
    width: 7.274,
    height: 99.471,
    transform: "translate(11.996 17.139) rotate(-44.999)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2668",
    "data-name": "Rectangle 2668",
    width: 7.274,
    height: 99.471,
    transform: "translate(0 53.373) rotate(-90)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2669",
    "data-name": "Rectangle 2669",
    width: 7.274,
    height: 99.471,
    transform: "translate(17.139 87.476) rotate(-135)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12462",
    "data-name": "Path 12462",
    d: "M131.95,372.188a34.065,34.065,0,1,0,34.069,34.064A34.063,34.063,0,0,0,131.95,372.188Z",
    transform: "translate(-82.218 -356.518)",
    fill: "#6a75b9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12463",
    "data-name": "Path 12463",
    d: "M138.744,353.128a59.921,59.921,0,1,0,59.924,59.917A59.916,59.916,0,0,0,138.744,353.128Zm0,104.518a44.6,44.6,0,1,1,44.6-44.6A44.6,44.6,0,0,1,138.744,457.646Z",
    transform: "translate(-78.827 -353.128)",
    fill: "#989fd7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12464",
    "data-name": "Path 12464",
    d: "M248.243,400.577H124.079a4.119,4.119,0,0,1-4.12-4.12h0a4.12,4.12,0,0,1,4.12-4.12H248.243a4.12,4.12,0,0,1,4.12,4.12h0A4.119,4.119,0,0,1,248.243,400.577Z",
    transform: "translate(-29.316 -144.427)",
    fill: "#45529a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12465",
    "data-name": "Path 12465",
    d: "M197.172,408.494h0a4.366,4.366,0,0,1-4.367-4.367V362.941a4.366,4.366,0,0,1,4.367-4.367h0a4.366,4.366,0,0,1,4.367,4.367v41.187A4.366,4.366,0,0,1,197.172,408.494Z",
    transform: "translate(-3.345 -156.464)",
    fill: "#45529a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12466",
    "data-name": "Path 12466",
    d: "M137.49,408.494h0a4.366,4.366,0,0,1-4.367-4.367V362.941a4.366,4.366,0,0,1,4.367-4.367h0a4.366,4.366,0,0,1,4.367,4.367v41.187A4.366,4.366,0,0,1,137.49,408.494Z",
    transform: "translate(-24.622 -156.464)",
    fill: "#45529a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12467",
    "data-name": "Path 12467",
    d: "M203.582,259.009H259.65a9.212,9.212,0,0,1,9.325,10.885l-15.984,111.59a12.993,12.993,0,0,1-12.443,10.885H184.481a9.213,9.213,0,0,1-9.326-10.885l15.985-111.59A12.992,12.992,0,0,1,203.582,259.009Z",
    transform: "translate(-9.678 -191.96)",
    fill: "#6a75b9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12468",
    "data-name": "Path 12468",
    d: "M158.505,370.24h0a3.874,3.874,0,0,1-3.874-3.873V319.024a3.874,3.874,0,0,1,3.874-3.873h0a3.872,3.872,0,0,1,3.873,3.873v47.344A3.872,3.872,0,0,1,158.505,370.24Z",
    transform: "translate(-16.954 -171.945)",
    fill: "#6a75b9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12469",
    "data-name": "Path 12469",
    d: "M271.656,365.763,131,368.906a6.483,6.483,0,0,1-6.628-6.338h0a6.484,6.484,0,0,1,6.338-6.628L271.368,352.8A6.485,6.485,0,0,1,278,359.135h0A6.484,6.484,0,0,1,271.656,365.763Z",
    transform: "translate(-27.743 -158.524)",
    fill: "#6a75b9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12470",
    "data-name": "Path 12470",
    d: "M192.557,323.011l-65.815,3.413a6.485,6.485,0,0,1-6.811-6.141h0a6.485,6.485,0,0,1,6.14-6.812l65.815-3.412a6.484,6.484,0,0,1,6.811,6.14h0A6.484,6.484,0,0,1,192.557,323.011Z",
    transform: "translate(-29.329 -173.763)",
    fill: "#989fd7"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10491",
    "data-name": "Group 10491",
    transform: "translate(0 149.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12471",
    "data-name": "Path 12471",
    d: "M91.845,402.5l-36.839,8.1a2.378,2.378,0,0,0-.2,4.592l56.716,17.833a3.89,3.89,0,0,0,5-3.018l2.661-14.7Z",
    transform: "translate(-53.138 -290.215)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12472",
    "data-name": "Path 12472",
    d: "M133.068,413.8,97.283,425.723a2.378,2.378,0,0,0,.279,4.588l58.276,11.78a3.891,3.891,0,0,0,4.651-3.527l1.1-14.9Z",
    transform: "translate(-37.98 -286.186)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12473",
    "data-name": "Path 12473",
    d: "M229.993,323.505,224.246,341.4l-11.9,7.9-27.826,18.453-32.173,1.229-6.232,10.9-37.1,64.939-27.335-12.8,39.515-79.68a27.313,27.313,0,0,1,19.385-14.694L200.439,326.3l13.706-6.571Z",
    transform: "translate(-42.965 -319.726)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12474",
    "data-name": "Path 12474",
    d: "M195.407,346.46,167.58,364.912l-32.172,1.229-6.232,10.9c2.156-8.766,5.727-19.322,11.482-27.156,11.821-16.083,52.02-22.21,52.02-22.21Z",
    transform: "translate(-26.03 -316.892)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12475",
    "data-name": "Path 12475",
    d: "M252.211,326.969l-.728,18.09a24.13,24.13,0,0,1-24.111,23.158H186.031L151.644,457.6,123,447.761l27.254-87.588a33.763,33.763,0,0,1,21.261-21.9l51.782-17.8Z",
    transform: "translate(-28.231 -319.459)",
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10494",
    "data-name": "Group 10494",
    transform: "translate(81.285 55.675)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12476",
    "data-name": "Path 12476",
    d: "M178.68,319.214l-43.7,2.066s-2.645,4.93-5.366,3.614.076-3.775.076-3.775-2.949,4.85-5.67,3.555-.517-3.474-.517-3.474a4.851,4.851,0,0,1-3.942,2.5c-2.8.163-1.89-3.635-1.89-3.635s-4.384,3.313-4.611.646,9.372-11.556,12.093-12.2,15.074,2.244,15.074,2.244l30.779-8.633,2.316-11.358,20.685,3.5-1.266,13.383a12.665,12.665,0,0,1-11.978,11.46Z",
    transform: "translate(-113.06 -236.313)",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10493",
    "data-name": "Group 10493",
    transform: "translate(60.266)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12477",
    "data-name": "Path 12477",
    d: "M218.314,325.3c-.02.007-.041-.007-.062-.042C218.323,325.276,218.343,325.291,218.314,325.3Z",
    transform: "translate(-135.823 -224.014)",
    fill: "url(#linear-gradient-9)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12478",
    "data-name": "Path 12478",
    d: "M247.613,305.952l-8.863-15.268s.02,7.986.1,18.2c.035,4.546.076,9.527.138,14.446.027,2.577.062,5.14.1,7.606.091,5.575.2,10.673.339,14.446a39.343,39.343,0,0,0,.49,6.494c-.952-.179-10.693-.359-22.437-.511-19.324-.248-44.069-.427-44.069-.427l.326-5.555.842-14.446.442-7.606.836-14.446.02-.3-8.676-1.651-9.713-1.852,8.172-30.976a24.384,24.384,0,0,1,16.221-17.023l16.539-5.229,2.6-.822,17.926-.4,3.828,1.064v.007l14.562,4.055A23.538,23.538,0,0,1,252.579,269l11.939,27.35Z",
    transform: "translate(-157.487 -250.624)",
    fill: "url(#linear-gradient-10)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12479",
    "data-name": "Path 12479",
    d: "M212.146,251.688v.007c-1.224,4.892-5.126,10.811-14.971,10.425-10.943-.422-10.4-6.929-9.382-10.273l2.6-.822,17.926-.4Z",
    transform: "translate(-146.862 -250.624)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12480",
    "data-name": "Path 12480",
    d: "M222.982,280.156s.152,59.335,1.167,61.187c-.952-.179-10.693-.359-22.437-.511Z",
    transform: "translate(-141.72 -240.095)",
    fill: "#b53b7c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10492",
    "data-name": "Group 10492",
    transform: "translate(16.248 58.257)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12481",
    "data-name": "Path 12481",
    d: "M235.156,324.272H169.465l.842-14.446h64.509C234.907,315.4,235.017,320.5,235.156,324.272Z",
    transform: "translate(-169.465 -287.775)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12482",
    "data-name": "Path 12482",
    d: "M234.376,308.016H170.412l.836-14.446h62.99C234.273,298.116,234.313,303.1,234.376,308.016Z",
    transform: "translate(-169.127 -293.57)",
    fill: "#fff"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12483",
    "data-name": "Path 12483",
    d: "M218.314,325.3c-.02.007-.041-.007-.062-.042C218.323,325.276,218.343,325.291,218.314,325.3Z",
    transform: "translate(-135.823 -224.014)",
    fill: "url(#linear-gradient-9)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12484",
    "data-name": "Path 12484",
    d: "M173.324,272.049v28.891l-8.677-1.651Z",
    transform: "translate(-154.934 -242.986)",
    fill: "#b53b7c"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12485",
    "data-name": "Path 12485",
    d: "M237.608,293.935l5.89,10.48-30.779,8.633s-12.352-2.889-15.074-2.244-12.321,9.536-12.093,12.2,4.609-.646,4.609-.646-.906,3.8,1.89,3.635a4.851,4.851,0,0,0,3.942-2.5s-2.2,2.181.518,3.474,5.669-3.555,5.669-3.555-2.8,2.459-.076,3.775,5.366-3.614,5.366-3.614l43.7-2.066a13.9,13.9,0,0,0,12.053-20.25l-8.706-16.925Z",
    transform: "translate(-87.217 -238.607)",
    fill: "url(#linear-gradient-12)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10497",
    "data-name": "Group 10497",
    transform: "translate(166.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12486",
    "data-name": "Path 12486",
    d: "M186.659,229.115c-7.823,3.366-11.434.575-9.464-3.447s5.007-4.6,5.007-4.6-6.812,2.6-6.32-2.515,15.363-11.438,29.1-7.991,13.741,12.393,13.741,12.393,6.131.651,4.513,8.783-8.618,22.654-14.363,20.109S186.659,229.115,186.659,229.115Z",
    transform: "translate(-175.856 -209.582)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10496",
    "data-name": "Group 10496",
    transform: "translate(9.201 15.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10495",
    "data-name": "Group 10495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12487",
    "data-name": "Path 12487",
    d: "M198.1,263.354c-9.844.864-8-6.031-8-6.031l-.138-1.989-.6-8.85,16.621-8.988.477,5.506,1.126,13.085S207.947,262.491,198.1,263.354Z",
    transform: "translate(-180.244 -214.922)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12488",
    "data-name": "Path 12488",
    d: "M206.455,243c-2,6.722-7.869,14.349-16.5,12.332l-.6-8.85,16.621-8.988Z",
    transform: "translate(-180.244 -214.922)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12489",
    "data-name": "Path 12489",
    d: "M183.22,220.855c15.8,9.767,25.035,4.514,25.035,4.514s-.822,12.451,2.047,12.81c.985.123,0-8.906,5.828-8.044s3.242,12.312-3.57,10.219c0,0-5.663,15.883-17.975,15.39s-11.943-15.019-11.943-15.019Z",
    transform: "translate(-182.639 -220.855)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12490",
    "data-name": "Path 12490",
    d: "M206.589,234.915c-2.923-.216-.1-6.58,2.156-4.247",
    transform: "translate(-174.547 -217.54)",
    fill: "none",
    stroke: "#453665",
    strokeLinecap: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12491",
    "data-name": "Path 12491",
    d: "M191.658,231.909l-2.032,6.563a1.038,1.038,0,0,0,1.317,1.291l2.192-.723",
    transform: "translate(-180.165 -216.914)",
    fill: "none",
    stroke: "#453665",
    strokeLinecap: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12492",
    "data-name": "Path 12492",
    d: "M187.543,232.943a1.3,1.3,0,1,1-1.3-1.3A1.3,1.3,0,0,1,187.543,232.943Z",
    transform: "translate(-181.815 -217.008)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12493",
    "data-name": "Path 12493",
    d: "M198.011,232.943a1.3,1.3,0,1,1-1.3-1.3A1.3,1.3,0,0,1,198.011,232.943Z",
    transform: "translate(-178.083 -217.008)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12494",
    "data-name": "Path 12494",
    d: "M194.711,227.666a5.445,5.445,0,0,1,5.663.288",
    transform: "translate(-178.335 -218.658)",
    fill: "none",
    stroke: "#453665",
    strokeLinecap: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12495",
    "data-name": "Path 12495",
    d: "M189.483,227.666a5.445,5.445,0,0,0-5.663.288",
    transform: "translate(-182.218 -218.658)",
    fill: "none",
    stroke: "#453665",
    strokeLinecap: "round",
    strokeWidth: 0.509
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12496",
    "data-name": "Path 12496",
    d: "M191.318,241.191a4.874,4.874,0,0,0,5.389-1.468",
    transform: "translate(-179.545 -214.128)",
    fill: "none",
    stroke: "#b14068",
    strokeLinecap: "round",
    strokeWidth: 0.509
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12497",
    "data-name": "Path 12497",
    d: "M258.478,324.654l-65.814,3.413a6.486,6.486,0,0,1-6.812-6.141h0a6.485,6.485,0,0,1,6.141-6.812l65.814-3.412a6.484,6.484,0,0,1,6.812,6.14h0A6.485,6.485,0,0,1,258.478,324.654Z",
    transform: "translate(-5.827 -173.177)",
    fill: "#989fd7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12498",
    "data-name": "Path 12498",
    d: "M218.583,370.24h0a3.874,3.874,0,0,1-3.874-3.873V319.024a3.874,3.874,0,0,1,3.874-3.873h0a3.874,3.874,0,0,1,3.874,3.873v47.344A3.874,3.874,0,0,1,218.583,370.24Z",
    transform: "translate(4.464 -171.945)",
    fill: "#989fd7"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10499",
    "data-name": "Group 10499",
    transform: "translate(159.489 194.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10498",
    "data-name": "Group 10498",
    transform: "translate(10.186 10.186)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2670",
    "data-name": "Rectangle 2670",
    width: 7.274,
    height: 99.471,
    transform: "translate(46.098)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2671",
    "data-name": "Rectangle 2671",
    width: 7.274,
    height: 99.471,
    transform: "translate(11.996 17.139) rotate(-44.999)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2672",
    "data-name": "Rectangle 2672",
    width: 7.274,
    height: 99.471,
    transform: "translate(0 53.373) rotate(-90)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2673",
    "data-name": "Rectangle 2673",
    width: 7.274,
    height: 99.471,
    transform: "translate(17.139 87.476) rotate(-135)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12499",
    "data-name": "Path 12499",
    d: "M223.834,372.188A34.065,34.065,0,1,0,257.9,406.252,34.063,34.063,0,0,0,223.834,372.188Z",
    transform: "translate(-174.101 -356.518)",
    fill: "#6a75b9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12500",
    "data-name": "Path 12500",
    d: "M230.628,353.128a59.921,59.921,0,1,0,59.924,59.917A59.915,59.915,0,0,0,230.628,353.128Zm0,104.518a44.6,44.6,0,1,1,44.6-44.6A44.6,44.6,0,0,1,230.628,457.646Z",
    transform: "translate(-170.711 -353.128)",
    fill: "#989fd7"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10506",
    "data-name": "Group 10506",
    transform: "translate(136.867 5.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10501",
    "data-name": "Group 10501",
    transform: "translate(93.42 144.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12501",
    "data-name": "Path 12501",
    d: "M330.139,476.847H301l-15.426-142.9L281.7,390.086l-5.983,86.761H247.155l5.582-189.605,24.062-7.385,44.607,4.186Z",
    transform: "translate(-214.255 -279.857)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12502",
    "data-name": "Path 12502",
    d: "M279.532,320.337l-3.869,56.137L264.1,318.037Z",
    transform: "translate(-208.215 -266.245)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12503",
    "data-name": "Path 12503",
    d: "M255.8,425.075l-31.858,18.371a2.075,2.075,0,0,0,1.038,3.873h59.087a2.074,2.074,0,0,0,2.067-2.259l-1.768-19.986Z",
    transform: "translate(-222.902 -228.084)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12504",
    "data-name": "Path 12504",
    d: "M290.023,425.075,280.014,442.3a3.342,3.342,0,0,0,2.889,5.022h34a3.343,3.343,0,0,0,3.33-3.637l-1.647-18.607Z",
    transform: "translate(-202.704 -228.084)",
    fill: "#6a75b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10503",
    "data-name": "Group 10503",
    transform: "translate(0 51.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12505",
    "data-name": "Path 12505",
    d: "M268.661,311.8h35.3l-12.5-100.842-17.522.406s-14.835,37.643-15.061,39.614",
    transform: "translate(-116.655 -210.963)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12506",
    "data-name": "Path 12506",
    d: "M212.909,292.991c1.313-6.811,12.358-15.676,12.358-15.676l9.639,6.4s-3.119,7.88-3.366,8.044-5.909,7.388-5.909,7.388l-3.612,4.35-2.79.821",
    transform: "translate(-133.045 -187.308)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10502",
    "data-name": "Group 10502",
    transform: "translate(0 99.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12507",
    "data-name": "Path 12507",
    d: "M210.727,320.365h0a3.693,3.693,0,0,1-1.968-4.837l12.336-29.271a3.693,3.693,0,0,1,4.837-1.97h0a3.693,3.693,0,0,1,1.97,4.837L215.565,318.4A3.7,3.7,0,0,1,210.727,320.365Z",
    transform: "translate(-134.628 -283.997)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12508",
    "data-name": "Path 12508",
    d: "M155.359,492.661h0a2.164,2.164,0,0,1-1.154-2.834l80.12-190.11a2.165,2.165,0,0,1,2.835-1.154h0a2.166,2.166,0,0,1,1.153,2.835l-80.12,190.109A2.163,2.163,0,0,1,155.359,492.661Z",
    transform: "translate(-154.035 -278.864)",
    fill: "url(#linear-gradient-24)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12509",
    "data-name": "Path 12509",
    d: "M217.805,303.686s-3.078-7.641-1.723-10.1,3.283,1.107,3.283,1.107-.164-5.581,1.97-6.278,2.873,2.5,2.873,2.5.246-4.5,1.56-5.678,2.462,2.149,2.462,2.149.041-2.79,1.559-3.611,3.489,7.346,2.873,9.726S220.474,312.6,217.805,303.686Z",
    transform: "translate(-132.036 -185.025)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12510",
    "data-name": "Path 12510",
    d: "M212.983,289.288s-1.38,14.676,1.949,12.971,2.853-10.508,1.888-13.381S212.983,289.288,212.983,289.288Z",
    transform: "translate(-133.119 -183.605)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12511",
    "data-name": "Path 12511",
    d: "M287.53,211.264,270.619,250.3l-4.946,28.013-1.119,6.335s-6.743,6.176-14.086,12.857c-8.636,7.854-18.1,16.407-18.363,16.407-.5,0-11.33-14.121-11.33-14.121l23.993-24.179,8.256-44.137a19,19,0,0,1,13.927-14.9Z",
    transform: "translate(-130.241 -210.856)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12512",
    "data-name": "Path 12512",
    d: "M257.869,268.742l-1.119,6.335s-6.743,6.176-14.086,12.857l12.545-49.817Z",
    transform: "translate(-122.437 -201.282)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12513",
    "data-name": "Path 12513",
    d: "M277.108,211.262l-24.153,26.811L250,316.54h25.609Z",
    transform: "translate(-119.821 -210.856)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12514",
    "data-name": "Path 12514",
    d: "M317.224,258.773l5.089,29.507,11.412-3.554V245.1l-6.487-2.46",
    transform: "translate(-95.855 -199.668)",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12515",
    "data-name": "Path 12515",
    d: "M338.854,249.221l-11.591,17.671L309.9,245.242v71.4H280.314l3.509-105.683,16.642,1.823a30.181,30.181,0,0,1,21.292,12.47Z",
    transform: "translate(-109.014 -210.963)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12516",
    "data-name": "Path 12516",
    d: "M253.267,233.75",
    transform: "translate(-118.657 -202.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12517",
    "data-name": "Path 12517",
    d: "M304.956,236.233v71.4h-10.77Z",
    transform: "translate(-104.068 -201.954)",
    fill: "url(#linear-gradient-32)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10505",
    "data-name": "Group 10505",
    transform: "translate(142.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10504",
    "data-name": "Group 10504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12518",
    "data-name": "Path 12518",
    d: "M265.3,186.841c-6.956-1.662-9.129-11.08-2.132-13.05s8.412,1.23,15.244.553,14.581-2.893,18.31,2.893,1.7,9.726,1.7,9.726,5.166-.062,3.38,6.772-5.7,10.484-8.433,15.821-8.372,5.54-9.481,4.063S265.3,186.841,265.3,186.841Z",
    transform: "translate(-258.88 -173.142)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12519",
    "data-name": "Path 12519",
    d: "M278.28,223.971c-9.844.863-8-6.031-8-6.031l-.138-1.99-.6-8.85,16.621-8.987.476,5.506,1.126,13.084S288.131,223.107,278.28,223.971Z",
    transform: "translate(-255.08 -164.239)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12520",
    "data-name": "Path 12520",
    d: "M286.639,203.619c-2,6.722-7.869,14.348-16.5,12.331l-.6-8.85,16.621-8.987Z",
    transform: "translate(-255.08 -164.239)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12521",
    "data-name": "Path 12521",
    d: "M263.4,181.471c15.8,9.768,25.034,4.515,25.034,4.515s-.822,12.451,2.047,12.81c.985.123,0-8.906,5.828-8.043s3.242,12.312-3.57,10.219c0,0-5.663,15.882-17.975,15.39s-11.943-15.021-11.943-15.021Z",
    transform: "translate(-257.475 -170.172)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12522",
    "data-name": "Path 12522",
    d: "M286.773,195.531c-2.923-.216-.1-6.58,2.155-4.247",
    transform: "translate(-249.382 -166.857)",
    fill: "none",
    stroke: "#453665",
    strokeLinecap: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12523",
    "data-name": "Path 12523",
    d: "M271.842,192.525l-2.032,6.563a1.038,1.038,0,0,0,1.317,1.291l2.192-.723",
    transform: "translate(-255.001 -166.232)",
    fill: "none",
    stroke: "#453665",
    strokeLinecap: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12524",
    "data-name": "Path 12524",
    d: "M267.727,193.558a1.3,1.3,0,1,1-1.3-1.3A1.294,1.294,0,0,1,267.727,193.558Z",
    transform: "translate(-256.65 -166.325)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_356",
    "data-name": "Ellipse 356",
    cx: 1.296,
    cy: 1.296,
    r: 1.296,
    transform: "translate(22.686 25.938)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_357",
    "data-name": "Ellipse 357",
    cx: 5.493,
    cy: 5.493,
    r: 5.493,
    transform: "translate(18.998 21.74)",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_358",
    "data-name": "Ellipse 358",
    cx: 5.493,
    cy: 5.493,
    r: 5.493,
    transform: "translate(4.288 21.74)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12525",
    "data-name": "Path 12525",
    d: "M274.9,188.283a5.445,5.445,0,0,1,5.663.288",
    transform: "translate(-253.171 -167.975)",
    fill: "none",
    stroke: "#453665",
    strokeLinecap: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12526",
    "data-name": "Path 12526",
    d: "M269.667,188.283a5.445,5.445,0,0,0-5.663.288",
    transform: "translate(-257.054 -167.975)",
    fill: "none",
    stroke: "#453665",
    strokeLinecap: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_192",
    "data-name": "Line 192",
    x2: 3.754,
    transform: "translate(15.244 26.653)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_193",
    "data-name": "Line 193",
    x2: 3.456,
    transform: "translate(29.903 26.294)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.509
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12527",
    "data-name": "Path 12527",
    d: "M271.5,201.807a4.871,4.871,0,0,0,5.389-1.468",
    transform: "translate(-254.381 -163.446)",
    fill: "none",
    stroke: "#b14068",
    strokeLinecap: "round",
    strokeWidth: 0.509
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10514",
    "data-name": "Group 10514",
    transform: "translate(337.757)"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12528",
    "data-name": "Path 12528",
    d: "M348.4,180.115c-13.953,6.237-11.491,22.655-7.552,27.332C329.2,216.394,320,238.719,346.6,249.061s48.262,7.715,54.007-10.178-1.806-33.768-7.55-38.225c4.6-14.142-1.805-26.588-20.847-30.557S348.4,180.115,348.4,180.115Z",
    transform: "translate(-292.421 -169.392)",
    fill: "url(#linear-gradient-41)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10509",
    "data-name": "Group 10509",
    transform: "translate(5.224 146.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12529",
    "data-name": "Path 12529",
    d: "M374,446.951h0a3.53,3.53,0,0,1-3.53-3.53V384.161a3.53,3.53,0,0,1,3.53-3.53h0a3.529,3.529,0,0,1,3.528,3.53v59.261A3.529,3.529,0,0,1,374,446.951Z",
    transform: "translate(-282.985 -240.731)",
    fill: "#4957a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12530",
    "data-name": "Path 12530",
    d: "M375.759,396.361h0a10.223,10.223,0,0,1-10.224-10.224V382.9h20.448v3.237A10.224,10.224,0,0,1,375.759,396.361Z",
    transform: "translate(-284.744 -239.922)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12531",
    "data-name": "Path 12531",
    d: "M377.019,392.09h0A15.019,15.019,0,0,1,362,377.071v-4.755h30.037v4.755A15.018,15.018,0,0,1,377.019,392.09Z",
    transform: "translate(-286.005 -243.695)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12532",
    "data-name": "Path 12532",
    d: "M404.4,405.3H373.864l-5.05-48.794L366.4,333.145l-1.319,16.6L354.907,477.688H327.329L333.6,302.279l.332-9.354,1.147-.712L358.845,277.5l44.241,15.426Z",
    transform: "translate(-298.365 -277.499)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12533",
    "data-name": "Path 12533",
    d: "M359.213,319.1l-1.319,16.6-10.418-18.818Z",
    transform: "translate(-291.183 -263.457)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10507",
    "data-name": "Group 10507",
    transform: "translate(0 200.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12534",
    "data-name": "Path 12534",
    d: "M359.606,434.242l-31.827,2.895-7.468-6.238,9.52-5.824h27.578Z",
    transform: "translate(-300.867 -425.075)",
    fill: "url(#linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12535",
    "data-name": "Path 12535",
    d: "M364.178,445.789H308.884a2.9,2.9,0,0,1-1.512-5.381l18.051-11.039,7.468,6.239,31.827-2.895,2.279,9.5A2.9,2.9,0,0,1,364.178,445.789Z",
    transform: "translate(-305.978 -423.544)",
    fill: "url(#linear-gradient-45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10508",
    "data-name": "Group 10508",
    transform: "translate(78.215 200.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12536",
    "data-name": "Path 12536",
    d: "M401.546,447.319H365.526c-1.219,0-2.12-1.754-1.837-3.579l1.485-9.5h0a10.839,10.839,0,0,1,10.71-9.167h4.4a10.835,10.835,0,0,1,7.42,2.938l3.073,2.885,11.76,11.039C404.16,443.472,403.454,447.319,401.546,447.319Z",
    transform: "translate(-363.636 -425.075)",
    fill: "#6a75b9"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2674",
    "data-name": "Rectangle 2674",
    width: 40.383,
    height: 12.798,
    rx: 3.313,
    transform: "translate(70.823 121.398)",
    fill: "#989fd7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10511",
    "data-name": "Group 10511",
    transform: "translate(0 55.894)"
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12537",
    "data-name": "Path 12537",
    d: "M344.922,294.336l-.856,9.657-1.148.712-.331,9.353L306.92,281.369a14.777,14.777,0,0,1-2.453-18.873l11.571-18.038,15.6,13.671-7.717,11.937Z",
    transform: "translate(-302.127 -198.524)",
    fill: "url(#linear-gradient-46)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12538",
    "data-name": "Path 12538",
    d: "M323.333,267.02s-5.6,5.007-4.74,6.546,5.171-1.293,5.171-1.293a4.989,4.989,0,0,0-1.355,4.493c.678,2.524,4.8-1.538,4.8-1.538s-3.694,1.785-2.709,4.371,4.247-1.293,4.247-1.293-3.2,1.909-1.784,3.939,6.2-1.538,6.3-3.939S330.229,261.891,323.333,267.02Z",
    transform: "translate(-296.288 -190.879)",
    fill: "url(#linear-gradient-47)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_194",
    "data-name": "Line 194",
    x1: 6.692,
    y1: 5.333,
    transform: "translate(15.103 66.21)",
    fill: "none",
    stroke: "#b14068",
    strokeLinecap: "round",
    strokeWidth: 0.509
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12539",
    "data-name": "Path 12539",
    d: "M431.068,255.548,415.476,265.96l-1.479.988-.567-.988-8.462-14.846.78,14.846.111,2.128.525,10.023.11,2.128.532,10.023.111,2.135.525,10.023.11,2.128.643,12.228H339.263s.5-5.292.849-12.228c.042-.69.069-1.4.1-2.128.138-3.2.235-6.646.235-10.023,0-.719-.007-1.43-.014-2.135a88.021,88.021,0,0,0-.615-10.023c-.1-.746-.208-1.458-.339-2.128-.069-.366-.145-.719-.221-1.057-.856-3.69-1.416-6.646-1.776-8.967-.117-.781-.221-1.492-.3-2.128a30.478,30.478,0,0,1-.345-4.829l-4.719,4.829-2.08,2.128-2.065,2.113-2.412-2.113-2.431-2.128-10.757-9.429,20.8-30.5a26.015,26.015,0,0,1,16.684-10.908l11.606-2.189,12.366-2.336,12.987,2.446,9.983,1.886a26.052,26.052,0,0,1,17.6,12.366Z",
    transform: "translate(-298.471 -210.596)",
    fill: "url(#linear-gradient-48)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12540",
    "data-name": "Path 12540",
    d: "M331.773,287.039c.153-.052,10.186-2.191,10.441,1.731s-5.449,3.718-5.449,3.718,6.366-.815,6.315,2.037-5.908,3.056-5.908,3.056,5.449-.662,5.3,2.444-8.607,4.837-11.51,3.463S326.222,287.446,331.773,287.039Z",
    transform: "translate(-292.837 -183.567)",
    fill: "url(#linear-gradient-49)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12541",
    "data-name": "Path 12541",
    d: "M388.421,306.128H368.463a77.484,77.484,0,0,0,8.794-19.039c5.748-19.047,0-30.211,7.717-46.625Z",
    transform: "translate(-278.477 -199.947)",
    fill: "url(#linear-gradient-50)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10510",
    "data-name": "Group 10510",
    transform: "translate(38.719 55.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12542",
    "data-name": "Path 12542",
    d: "M400.484,280.416h-67.66c.042-.69.069-1.4.1-2.128h67.446Z",
    transform: "translate(-329.902 -241.826)",
    fill: "#fff",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12543",
    "data-name": "Path 12543",
    d: "M399.764,271.46H333.078c0-.719-.007-1.43-.014-2.135h66.589Z",
    transform: "translate(-329.817 -245.022)",
    fill: "#fff",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12544",
    "data-name": "Path 12544",
    d: "M399.372,262.5H332.7c-.1-.746-.208-1.458-.339-2.128h66.9Z",
    transform: "translate(-330.067 -248.215)",
    fill: "#fff",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12545",
    "data-name": "Path 12545",
    d: "M399.228,251.409l.111,2.128H330.967c-.117-.781-.221-1.492-.3-2.128Z",
    transform: "translate(-330.67 -251.409)",
    fill: "#fff",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12546",
    "data-name": "Path 12546",
    d: "M338.818,232c-.822,5.084-5.582,10.508-6.072,21.5l-8.867,9.068Z",
    transform: "translate(-294.372 -202.967)",
    fill: "url(#linear-gradient-51)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12547",
    "data-name": "Path 12547",
    d: "M404.571,255.133l5.252,9.12-38.345-3.775s-8.912-9.234-10.574-8.188-1.416,2.364-.554,3.645S362.629,259,362.629,259l-11.635.246s-5.848-6.278-7.388-5.171.677,4.8.677,4.8-3.631-1.785-4.432,0,1.846,4.494,1.846,4.494-1.662-1.5-2.77.882,6.833,6.875,8.741,7.613,20.992.308,20.992.308l48.673,11.765a13.588,13.588,0,0,0,15.208-19.55l-10.9-20.654Z",
    transform: "translate(-289.044 -198.782)",
    fill: "url(#linear-gradient-52)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_195",
    "data-name": "Line 195",
    x2: 11.817,
    y2: 1.478,
    transform: "translate(120.779 65.471)",
    fill: "none",
    stroke: "#b14068",
    strokeLinecap: "round",
    strokeWidth: 0.509
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10513",
    "data-name": "Group 10513",
    transform: "translate(55.164 13.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12548",
    "data-name": "Path 12548",
    d: "M374.175,213.042c-.925,5.928-4.207,16.815-15.84,15.911-12.835-.989-10.791-11.848-9.513-16.02l12.366-2.336Z",
    transform: "translate(-340.983 -168.3)",
    fill: "url(#linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10512",
    "data-name": "Group 10512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12549",
    "data-name": "Path 12549",
    d: "M359.031,224.149c-9.844.864-8-6.031-8-6.031l-.138-1.99-.6-8.849,16.621-8.988.476,5.506,1.126,13.085S368.882,223.285,359.031,224.149Z",
    transform: "translate(-340.119 -172.687)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12550",
    "data-name": "Path 12550",
    d: "M367.39,203.8c-2,6.722-7.869,14.348-16.5,12.331l-.6-8.849,16.621-8.988Z",
    transform: "translate(-340.119 -172.687)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12551",
    "data-name": "Path 12551",
    d: "M343.742,179.416c9.481,11.941,24.942,11.16,24.942,11.16s-.317,8.835,2.552,9.194c.985.122,0-8.906,5.828-8.044s3.242,12.312-3.57,10.219c0,0-5.663,15.882-17.975,15.39s-11.943-15.021-11.943-15.021Z",
    transform: "translate(-342.514 -179.416)",
    fill: "url(#linear-gradient-56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12552",
    "data-name": "Path 12552",
    d: "M357.6,200.021a2.75,2.75,0,0,1-5.459.666",
    transform: "translate(-339.458 -172.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12553",
    "data-name": "Path 12553",
    d: "M367.524,195.711c-2.923-.216-.1-6.582,2.155-4.249",
    transform: "translate(-334.422 -175.304)",
    fill: "none",
    stroke: "#453665",
    strokeLinecap: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12554",
    "data-name": "Path 12554",
    d: "M352.593,192.7l-2.032,6.561a1.038,1.038,0,0,0,1.317,1.293l2.192-.724",
    transform: "translate(-340.04 -174.679)",
    fill: "none",
    stroke: "#453665",
    strokeLinecap: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_359",
    "data-name": "Ellipse 359",
    cx: 1.296,
    cy: 1.296,
    r: 1.296,
    transform: "translate(4.198 17.669)",
    fill: "url(#linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_360",
    "data-name": "Ellipse 360",
    cx: 1.296,
    cy: 1.296,
    r: 1.296,
    transform: "translate(18.397 17.669)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_361",
    "data-name": "Ellipse 361",
    cx: 5.493,
    cy: 5.493,
    r: 5.493,
    transform: "translate(14.71 13.471)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_362",
    "data-name": "Ellipse 362",
    cx: 5.493,
    cy: 5.493,
    r: 5.493,
    transform: "translate(0 13.471)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12555",
    "data-name": "Path 12555",
    d: "M355.646,188.461a5.445,5.445,0,0,1,5.664.288",
    transform: "translate(-338.21 -176.423)",
    fill: "none",
    stroke: "#453665",
    strokeLinecap: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12556",
    "data-name": "Path 12556",
    d: "M350.418,188.461a5.445,5.445,0,0,0-5.663.288",
    transform: "translate(-342.093 -176.423)",
    fill: "none",
    stroke: "#453665",
    strokeLinecap: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_196",
    "data-name": "Line 196",
    x2: 3.754,
    transform: "translate(10.956 18.384)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.509
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_197",
    "data-name": "Line 197",
    x2: 3.456,
    transform: "translate(25.614 18.025)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.509
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.d9111819949230a30da58f2d08357de3.svg";
export { ForwardRef as ReactComponent };